import { Stack, Typography } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../../state/state';
import { getAmountDue, isOnMonthlyBillPlan } from '../../state/helpers';
import { CurrentPayPlan } from '@ace-clublabs/common-membership-api-types';

export const CardBanner = () => {
  const [membershipDetails] = useGlobalState('memberDetails');
  const [paymentInfo] = useGlobalState('paymentInfo');
  const [priceCart] = useGlobalState('priceCart');

  const { inRenewal, hasPaymentInTransit, currentBillPlan } = membershipDetails;
  const isMonthlyBillPlan = isOnMonthlyBillPlan(currentBillPlan as CurrentPayPlan);
  const amountDue = getAmountDue(membershipDetails, paymentInfo.monthlyPaymentData, priceCart);

  const getBannerMessage = () => {
    if (inRenewal && !hasPaymentInTransit && amountDue > 0 && !isMonthlyBillPlan)
      return 'Time to renew your membership!';
  };

  const bannerMessage = getBannerMessage();

  return (
    <>
      {bannerMessage && (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ backgroundColor: '#FFEDC2', height: '36px', width: '100%', color: '#A24531' }}
          className="card-banner-container"
        >
          <Typography variant="b1Medium" sx={{ color: '#A24531' }}>
            {bannerMessage}
          </Typography>
        </Stack>
      )}
    </>
  );
};
